import { validateDateRangeSearch } from "./lib/date-range-search";

export function validateFinalizationsSearch(search: Record<string, unknown>) {
  return {
    ...validateDateRangeSearch(search),
    assignedTo:
      typeof search.assignedTo === "string" && search.assignedTo.trim()
        ? search.assignedTo
        : undefined,
    source: search.source === "all" || search.source === "other" ? search.source : "dialer",
  };
}
